export default __webpack_public_path__ + "static/media/premium_normal-available_loan.ffa62f4d.jpg";